/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCart = {
  init: function ($section) {

    // Add settings from schema to current object
    //Shopify.theme.jsCart = $.extend(this, Shopify.theme.getSectionData($section));

    this.$section = $section;

    jQuery(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineID = jQuery(this).data('line-item-key');
      Shopify.theme.jsCart.removeFromCart(lineID);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    jQuery('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },
  removeFromCart: function (lineID) {
    const $cartItem = Shopify.theme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    $cartItem.css('opacity', '0.5');

    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {

        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();

        Shopify.theme.jsCart.updateView(cart, lineID);

        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  updateView: function (cart, lineID) {

    if (cart.item_count > 0) {
      jQuery.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {

          if (lineID !== null) {

            const updatedItems = jQuery(html).find('.cart__item-list .cart__card');
            const currentItems = jQuery('.cart__item-list .cart__card');

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length){
              const updatedCartList = jQuery(html).find('.cart__item-list');
              // Re-append cart items
              jQuery('.cart__item-list').replaceWith(updatedCartList);
            }

            jQuery(currentItems).each(function(index, element){
              jQuery(element).attr('data-line-item', (index + 1));
              jQuery(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
            })

            const itemTotal = jQuery(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
            const quantityInput = jQuery(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
            const itemPrice = jQuery(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

            jQuery(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            jQuery(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            jQuery(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

          }

          const subtotal = jQuery(html).find('.cart__subtotal-container');
          const discounts = jQuery(html).find('.cart__discounts');
          const savings = jQuery(html).find('.cart__total-savings');

          jQuery('.cart__subtotal-container').replaceWith(subtotal);

          if (discounts.length > 0 && jQuery('.cart__discounts').length < 1) {
            jQuery('.cart__subtotal-container').before(discounts);
          } else {
            jQuery('.cart__discounts').replaceWith(discounts);
          }

          if (savings.length > 0 && jQuery('.cart__total-savings').length < 1) {
            jQuery('.cart__subtotal-container').after(savings);
          } else {
            jQuery('.cart__total-savings').replaceWith(savings);
          }
          
          jQuery('.discount-progressbar--wrapper').replaceWith(jQuery(html).find('.discount-progressbar--wrapper'));

          jQuery('[data-bind="itemCount"]').text(cart.item_count);

        }
      });

    } else {
      jQuery('.cart__empty-cart-message').removeClass('is-hidden');
      jQuery('.cart__form').addClass('is-hidden');
      jQuery('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      jQuery('[data-bind="itemCount"]').text('0');
    }

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    jQuery('[data-cart-page-delete]').off();
    jQuery('#cart_form').off();
  }
}

/******/ })()
;